export default[{
    "text": "兽医服务",
    "value": "0742"
  }, {
    "text": "农业合作",
    "value": "0763"
  }, {
    "text": "景观美化及园艺服务",
    "value": "0780"
  }, {
    "text": "⼀般承包商－住宅与商业楼",
    "value": "1520"
  }, {
    "text": "中华⼈⺠共和国铁道部",
    "value": "3998"
  }, {
    "text": "铁路运输",
    "value": "4011"
  }, {
    "text": "本市和市郊通勤旅客运输（包括轮渡）",
    "value": "4111"
  }, {
    "text": "铁路客运",
    "value": "4112"
  }, {
    "text": "救护⻋服务",
    "value": "4119"
  }, {
    "text": "出租⻋服务",
    "value": "4121"
  }, {
    "text": "公路客运",
    "value": "4131"
  }, {
    "text": "货物搬运和托运—当地⻓途，移动和存储公司",
    "value": "4214"
  }, {
    "text": "快递服务（空运、地⾯运输或海运）",
    "value": "4215"
  }, {
    "text": "公共仓储服务－农产品、冷冻品和家⽤产品",
    "value": "4225"
  }, {
    "text": "轮船及巡游航线服务",
    "value": "4411"
  }, {
    "text": "出租船只",
    "value": "4457"
  }, {
    "text": "烟草配送",
    "value": "4458"
  }, {
    "text": "船舶、海运服务提供商",
    "value": "4468"
  }, {
    "text": "航空公司",
    "value": "4511"
  }, {
    "text": "机场服务",
    "value": "4582"
  }, {
    "text": "旅⾏社",
    "value": "4722"
  }, {
    "text": "⼤型景区售票",
    "value": "4733"
  }, {
    "text": "路桥通⾏费",
    "value": "4784"
  }, {
    "text": "未列⼊其他代码的运输服务",
    "value": "4789"
  }, {
    "text": "通讯设备和电话销售",
    "value": "4812"
  }, {
    "text": "电信服务，包括本地⻓途信⽤卡磁卡电话传真",
    "value": "4814"
  }, {
    "text": "计算机⽹络/信息服务",
    "value": "4816"
  }, {
    "text": "电报服务",
    "value": "4821"
  }, {
    "text": "有线和其他付费电视服务",
    "value": "4899"
  }, {
    "text": "公共事业（电⼒、煤⽓、⾃来⽔、清洁服务）",
    "value": "4900"
  }, {
    "text": "机动⻋供应及零配件（批发商）",
    "value": "5013"
  }, {
    "text": "办公及商务家具（批发商）",
    "value": "5021"
  }, {
    "text": "未列⼊其他代码的建材批发（批发商）",
    "value": "5039"
  }, {
    "text": "办公、影印及微缩摄影器材（批发商）",
    "value": "5044"
  }, {
    "text": "计算机、计算机外围设备（批发商）",
    "value": "5045"
  }, {
    "text": "未列⼊其他代码的商⽤器材（批发商）",
    "value": "5046"
  }, {
    "text": "⽛科/实验室/医疗/眼科医院器材和⽤品(批)",
    "value": "5047"
  }, {
    "text": "⾦属产品服务商和公司（批发商）",
    "value": "5051"
  }, {
    "text": "电器零件和设备（批发商）",
    "value": "5065"
  }, {
    "text": "三⾦器材及⽤品（批发商）",
    "value": "5072"
  }, {
    "text": "管道和供暖设备（批发商）",
    "value": "5074"
  }, {
    "text": "贵重珠宝、⾸饰，钟表零售",
    "value": "5094"
  }, {
    "text": "⽂具、办公⽤品、复印纸和书写纸（批发商）",
    "value": "5111"
  }, {
    "text": "药品、药品经营者（批发商）",
    "value": "5122"
  }, {
    "text": "布料、缝纫⽤品和其他纺织品（批发商）",
    "value": "5131"
  }, {
    "text": "男⼥及⼉童制服和服装（批发商）",
    "value": "5137"
  }, {
    "text": "鞋类（批发商）",
    "value": "5139"
  }, {
    "text": "⽯油及⽯油产品（批发商）",
    "value": "5172"
  }, {
    "text": "书、期刊和报纸（批发商）",
    "value": "5192"
  }, {
    "text": "花⽊栽种⽤品、苗⽊和花卉（批发商）",
    "value": "5193"
  }, {
    "text": "油漆、清漆⽤品（批发商）",
    "value": "5198"
  }, {
    "text": "⼤型仓储式家庭⽤品卖场",
    "value": "5200"
  }, {
    "text": "⽊材和各类建材卖场",
    "value": "5211"
  }, {
    "text": "玻璃、油漆涂料、墙纸零售",
    "value": "5231"
  }, {
    "text": "五⾦商店",
    "value": "5251"
  }, {
    "text": "草坪、花园⽤品商店",
    "value": "5261"
  }, {
    "text": "活动房⻋销售商",
    "value": "5271"
  }, {
    "text": "会员制批量零售店",
    "value": "5300"
  }, {
    "text": "免税商店",
    "value": "5309"
  }, {
    "text": "折扣商店",
    "value": "5310"
  }, {
    "text": "百货商店",
    "value": "5311"
  }, {
    "text": "各类杂货店、便利店",
    "value": "5331"
  }, {
    "text": "⼤型企业批发",
    "value": "5398"
  }, {
    "text": "其他综合零售",
    "value": "5399"
  }, {
    "text": "⼤型仓储式超级市场",
    "value": "5411"
  }, {
    "text": "各类⾁类零售商",
    "value": "5422"
  }, {
    "text": "糖果及坚果商店",
    "value": "5441"
  }, {
    "text": "乳制品店、冷饮店",
    "value": "5451"
  }, {
    "text": "⾯包房、糕点商店",
    "value": "5462"
  }, {
    "text": "各类⻝品店及专⻔⻝品零售店",
    "value": "5499"
  }, {
    "text": "汽⻋货⻋经销商－新旧⻋的销售服务维修零件",
    "value": "5511"
  }, {
    "text": "汽⻋货⻋经销商－专⻔从事旧⻋销售服务维修",
    "value": "5521"
  }, {
    "text": "汽⻋轮胎经销商",
    "value": "5532"
  }, {
    "text": "汽⻋零配件商店",
    "value": "5533"
  }, {
    "text": "加油站、服务站",
    "value": "5541"
  }, {
    "text": "⾃助加油站",
    "value": "5542"
  }, {
    "text": "船只销售商",
    "value": "5551"
  }, {
    "text": "旅⾏拖⻋、娱乐⽤⻋销售商",
    "value": "5561"
  }, {
    "text": "摩托⻋商店和经销商",
    "value": "5571"
  }, {
    "text": "露营、房⻋销售商",
    "value": "5592"
  }, {
    "text": "雪⻋商",
    "value": "5598"
  }, {
    "text": "汽⻋、⻜⾏器、农⽤机⻋综合经营商",
    "value": "5599"
  }, {
    "text": "男⼦和男童服装及⽤品商店",
    "value": "5611"
  }, {
    "text": "妇⼥成⾐商店",
    "value": "5621"
  }, {
    "text": "⼥性⽤品商店",
    "value": "5631"
  }, {
    "text": "婴⼉、⼉童服装店",
    "value": "5641"
  }, {
    "text": "家庭服装商店",
    "value": "5651"
  }, {
    "text": "运动服饰商店",
    "value": "5655"
  }, {
    "text": "鞋店",
    "value": "5661"
  }, {
    "text": "⽪货店",
    "value": "5681"
  }, {
    "text": "成⼈成⾐店",
    "value": "5691"
  }, {
    "text": "裁缝、修补、改⾐店",
    "value": "5697"
  }, {
    "text": "假发商店",
    "value": "5698"
  }, {
    "text": "各类服装及饰物店",
    "value": "5699"
  }, {
    "text": "家具、家庭摆品、家⽤设备零售商",
    "value": "5712"
  }, {
    "text": "地板商店",
    "value": "5713"
  }, {
    "text": "帏帐、窗帘、室内装潢商店",
    "value": "5714"
  }, {
    "text": "壁炉、壁炉防护⽹及配件商店",
    "value": "5718"
  }, {
    "text": "各种家庭装饰专营店",
    "value": "5719"
  }, {
    "text": "家⽤电器商店",
    "value": "5722"
  }, {
    "text": "电⼦设备商店",
    "value": "5732"
  }, {
    "text": "⾳乐商店－乐器、钢琴、乐谱",
    "value": "5733"
  }, {
    "text": "计算机软件商店",
    "value": "5734"
  }, {
    "text": "⾳像制品商店",
    "value": "5735"
  }, {
    "text": "包办伙⻝，宴会承包商",
    "value": "5811"
  }, {
    "text": "就餐场所和餐馆",
    "value": "5812"
  }, {
    "text": "饮酒场所(酒吧/夜总会/鸡尾酒⼤厅/舞厅)",
    "value": "5813"
  }, {
    "text": "快餐店",
    "value": "5814"
  }, {
    "text": "药房、药店",
    "value": "5912"
  }, {
    "text": "瓶装酒零售店",
    "value": "5921"
  }, {
    "text": "旧商品店、⼆⼿商品店",
    "value": "5931"
  }, {
    "text": "古玩店——出售、维修及还原",
    "value": "5932"
  }, {
    "text": "当铺（典当、拍卖和信托类）",
    "value": "5933"
  }, {
    "text": "海上船只遇难救助",
    "value": "5935"
  }, {
    "text": "古玩复制店",
    "value": "5937"
  }, {
    "text": "⾃⾏⻋商店",
    "value": "5940"
  }, {
    "text": "体育⽤品店",
    "value": "5941"
  }, {
    "text": "书店",
    "value": "5942"
  }, {
    "text": "⽂具⽤品商店、各类办公⽤品商店",
    "value": "5943"
  }, {
    "text": "银器店",
    "value": "5944"
  }, {
    "text": "玩具、游戏店",
    "value": "5945"
  }, {
    "text": "照相器材商店",
    "value": "5946"
  }, {
    "text": "礼品、卡⽚、装饰品、纪念品商店",
    "value": "5947"
  }, {
    "text": "箱包、⽪具店",
    "value": "5948"
  }, {
    "text": "纺织品及针织品零售",
    "value": "5949"
  }, {
    "text": "玻璃器⽫和⽔晶饰品店",
    "value": "5950"
  }, {
    "text": "直销－保险直销",
    "value": "5960"
  }, {
    "text": "旅游相关服务直销",
    "value": "5962"
  }, {
    "text": "⻔对⻔销售",
    "value": "5963"
  }, {
    "text": "⽬录销售商户",
    "value": "5964"
  }, {
    "text": "⽬录、零售兼营商户",
    "value": "5965"
  }, {
    "text": "电话呼出直销",
    "value": "5966"
  }, {
    "text": "电话呼⼊直销",
    "value": "5967"
  }, {
    "text": "订阅/订购直销服务",
    "value": "5968"
  }, {
    "text": "其他直销商户",
    "value": "5969"
  }, {
    "text": "⼯艺美术商店",
    "value": "5970"
  }, {
    "text": "艺术商和画廊",
    "value": "5971"
  }, {
    "text": "邮票和纪念币商店",
    "value": "5972"
  }, {
    "text": "宗教品商店",
    "value": "5973"
  }, {
    "text": "助听器－销售、服务和⽤品",
    "value": "5975"
  }, {
    "text": "假肢店（整形外科⽤品、辅助设备）",
    "value": "5976"
  }, {
    "text": "化妆品商店",
    "value": "5977"
  }, {
    "text": "打字机商店—销售、服务和出租",
    "value": "5978"
  }, {
    "text": "燃料经销商－燃油、⽊材、煤炭和液化⽯油",
    "value": "5983"
  }, {
    "text": "花店",
    "value": "5992"
  }, {
    "text": "⾹烟、雪茄专卖店",
    "value": "5993"
  }, {
    "text": "报亭、报摊",
    "value": "5994"
  }, {
    "text": "宠物商店、宠物⻝品及⽤品",
    "value": "5995"
  }, {
    "text": "游泳池－销售、供应和服务",
    "value": "5996"
  }, {
    "text": "电动剃须⼑商店－销售和服务",
    "value": "5997"
  }, {
    "text": "其他批发商",
    "value": "5998"
  }, {
    "text": "其他专⻔零售店",
    "value": "5999"
  }, {
    "text": "⾦融机构－⼈⼯现⾦⽀付",
    "value": "6010"
  }, {
    "text": "⾦融机构－⾃动现⾦⽀付",
    "value": "6011"
  }, {
    "text": "⾦融机构－商品和服务",
    "value": "6012"
  }, {
    "text": "⾦融机构－农⺠⼯现⾦⽀付",
    "value": "6050"
  }, {
    "text": "⾮⾦融机构－外币兑换、⾮电⼦转账的汇票",
    "value": "6051"
  }, {
    "text": "证券公司－经纪⼈和经销商",
    "value": "6211"
  }, {
    "text": "保险销售、保险业和保险⾦",
    "value": "6300"
  }, {
    "text": "不动产管理－物业管理",
    "value": "6513"
  }, {
    "text": "住宿服务(旅馆、酒店、汽⻋旅馆、度假村等)",
    "value": "7011"
  }, {
    "text": "分时使⽤的别墅或度假⽤房",
    "value": "7012"
  }, {
    "text": "不动产代理——房地产经纪",
    "value": "7013"
  }, {
    "text": "运动和娱乐露营地",
    "value": "7032"
  }, {
    "text": "活动房⻋场及露营场所",
    "value": "7033"
  }, {
    "text": "洗⾐店",
    "value": "7210"
  }, {
    "text": "洗熨服务（⾃助洗⾐服务）",
    "value": "7211"
  }, {
    "text": "⼲洗店",
    "value": "7216"
  }, {
    "text": "室内清洁服务(地毯沙发家具表⾯的清洁服务)",
    "value": "7217"
  }, {
    "text": "摄影⼯作室",
    "value": "7221"
  }, {
    "text": "美容理发店",
    "value": "7230"
  }, {
    "text": "修鞋店、擦鞋店、帽⼦清洗店",
    "value": "7251"
  }, {
    "text": "殡葬服务",
    "value": "7261"
  }, {
    "text": "婚姻介绍及陪同服务",
    "value": "7273"
  }, {
    "text": "税收准备服务",
    "value": "7276"
  }, {
    "text": "咨询服务－债务、婚姻和私⼈事务",
    "value": "7277"
  }, {
    "text": "购物服务及会所（贸易、经纪服务）",
    "value": "7278"
  }, {
    "text": "家政服务",
    "value": "7295"
  }, {
    "text": "出租⾐物－服装、制服和正式场合服装",
    "value": "7296"
  }, {
    "text": "按摩店",
    "value": "7297"
  }, {
    "text": "保健及美容SPA",
    "value": "7298"
  }, {
    "text": "未列⼊其他代码的其他个⼈服务",
    "value": "7299"
  }, {
    "text": "⼴告服务",
    "value": "7311"
  }, {
    "text": "消费者信⽤报告机构",
    "value": "7321"
  }, {
    "text": "商业摄影、⼯艺、绘图服务",
    "value": "7333"
  }, {
    "text": "复印及绘图服务",
    "value": "7338"
  }, {
    "text": "速记、秘书服务（包括各类办公服务）",
    "value": "7339"
  }, {
    "text": "灭⾍及消毒服务",
    "value": "7342"
  }, {
    "text": "清洁、保养及⻔卫服务",
    "value": "7349"
  }, {
    "text": "职业中介、临时⼯",
    "value": "7361"
  }, {
    "text": "计算机编程、数据处理和系统集成设计服务",
    "value": "7372"
  }, {
    "text": "信息检索服务",
    "value": "7375"
  }, {
    "text": "未列⼊其他代码的计算机维护和修理服务",
    "value": "7379"
  }, {
    "text": "管理、咨询和公共关系服务",
    "value": "7392"
  }, {
    "text": "侦探、保安、安全服务",
    "value": "7393"
  }, {
    "text": "设备、⼯具、家具和电器出租",
    "value": "7394"
  }, {
    "text": "照相洗印服务",
    "value": "7395"
  }, {
    "text": "未列⼊其他代码的商业服务",
    "value": "7399"
  }, {
    "text": "汽⻋出租",
    "value": "7512"
  }, {
    "text": "卡⻋及拖⻋出租",
    "value": "7513"
  }, {
    "text": "房⻋和娱乐⻋辆出租",
    "value": "7519"
  }, {
    "text": "停⻋场",
    "value": "7523"
  }, {
    "text": "⻋体维修店",
    "value": "7531"
  }, {
    "text": "轮胎翻新、维修店",
    "value": "7534"
  }, {
    "text": "汽⻋喷漆店",
    "value": "7535"
  }, {
    "text": "汽⻋服务商店（⾮经销商）",
    "value": "7538"
  }, {
    "text": "洗⻋",
    "value": "7542"
  }, {
    "text": "拖⻋服务",
    "value": "7549"
  }, {
    "text": "电器设备维修",
    "value": "7622"
  }, {
    "text": "空调、制冷设备维修",
    "value": "7623"
  }, {
    "text": "电器设备、⼩家电维修",
    "value": "7629"
  }, {
    "text": "⼿表、钟表和⾸饰维修店",
    "value": "7631"
  }, {
    "text": "家具维修、翻新",
    "value": "7641"
  }, {
    "text": "焊接维修服务",
    "value": "7692"
  }, {
    "text": "各类维修店及相关服务",
    "value": "7699"
  }, {
    "text": "电影和录像创作、发⾏",
    "value": "7829"
  }, {
    "text": "电影院",
    "value": "7832"
  }, {
    "text": "⾳像制品出租商店",
    "value": "7841"
  }, {
    "text": "歌舞厅",
    "value": "7911"
  }, {
    "text": "戏剧制⽚（不含电影）、演出和票务",
    "value": "7922"
  }, {
    "text": "未列⼊其他代码的乐队、⽂艺表演",
    "value": "7929"
  }, {
    "text": "台球、撞球场所",
    "value": "7932"
  }, {
    "text": "保龄球馆",
    "value": "7933"
  }, {
    "text": "商业体育场馆、职业体育俱乐部、运动场",
    "value": "7941"
  }, {
    "text": "旅游与展览",
    "value": "7991"
  }, {
    "text": "公共⾼尔夫球场",
    "value": "7992"
  }, {
    "text": "电⼦游戏供给",
    "value": "7993"
  }, {
    "text": "⼤型游戏机和游戏场所",
    "value": "7994"
  }, {
    "text": "彩票销售",
    "value": "7995"
  }, {
    "text": "游乐园、⻢戏团、嘉年华、占⼘",
    "value": "7996"
  }, {
    "text": "会员俱乐部、乡村俱乐部以及私⼈⾼尔夫课程",
    "value": "7997"
  }, {
    "text": "⽔族馆、海洋馆和海豚馆",
    "value": "7998"
  }, {
    "text": "未列⼊其他代码的娱乐服务",
    "value": "7999"
  }, {
    "text": "其他医疗卫⽣活动",
    "value": "8011"
  }, {
    "text": "⽛科医⽣",
    "value": "8021"
  }, {
    "text": "正⻣医⽣",
    "value": "8031"
  }, {
    "text": "按摩医⽣",
    "value": "8041"
  }, {
    "text": "眼科医⽣",
    "value": "8042"
  }, {
    "text": "光学产品、眼镜店",
    "value": "8043"
  }, {
    "text": "⼿⾜病医⽣",
    "value": "8049"
  }, {
    "text": "护理和照料服务",
    "value": "8050"
  }, {
    "text": "公⽴医院",
    "value": "8062"
  }, {
    "text": "医学及⽛科实验室",
    "value": "8071"
  }, {
    "text": "其他医疗保健服务",
    "value": "8099"
  }, {
    "text": "法律服务和律师事务所服务",
    "value": "8111"
  }, {
    "text": "中⼩学校（公⽴）",
    "value": "8211"
  }, {
    "text": "普通⾼校（公⽴）",
    "value": "8220"
  }, {
    "text": "函授学校（成⼈教育）",
    "value": "8241"
  }, {
    "text": "商业和⽂秘学校（中等专业学校）",
    "value": "8244"
  }, {
    "text": "贸易和职业学校（职业技能培训）",
    "value": "8249"
  }, {
    "text": "其他学校和教育服务",
    "value": "8299"
  }, {
    "text": "⼉童保育服务（含学前教育）",
    "value": "8351"
  }, {
    "text": "慈善和社会公益服务组织",
    "value": "8398"
  }, {
    "text": "市⺠、社会及友爱组织",
    "value": "8641"
  }, {
    "text": "政治组织（政府机构）",
    "value": "8651"
  }, {
    "text": "宗教组织",
    "value": "8661"
  }, {
    "text": "汽⻋协会",
    "value": "8675"
  }, {
    "text": "其他会员组织",
    "value": "8699"
  }, {
    "text": "建筑、⼯程和测量服务",
    "value": "8911"
  }, {
    "text": "装修、装潢、园艺",
    "value": "8912"
  }, {
    "text": "会计、审计、财务服务",
    "value": "8931"
  }, {
    "text": "未列⼊其他代码的专业服务",
    "value": "8999"
  }, {
    "text": "法庭费⽤，包括赡养费和⼦⼥抚养费",
    "value": "9211"
  }, {
    "text": "罚款",
    "value": "9222"
  }, {
    "text": "保释⾦",
    "value": "9223"
  }, {
    "text": "纳税",
    "value": "9311"
  }, {
    "text": "未列⼊其他代码的政府服务（社会保障服务）",
    "value": "9399"
  }, {
    "text": "使领馆收费",
    "value": "9400"
  }, {
    "text": "国家邮政服务",
    "value": "9402"
  }, {
    "text": "信⽤卡还款",
    "value": "9498"
  }, {
    "text": "县乡优惠—宾馆餐饮娱乐类",
    "value": "9703"
  }, {
    "text": "县乡优惠—房产汽⻋类",
    "value": "9704"
  }, {
    "text": "县乡优惠—批发类",
    "value": "9705"
  }, {
    "text": "县乡优惠—超市加油类",
    "value": "9706"
  }, {
    "text": "县乡优惠—⼀般商户类",
    "value": "9707"
  }, {
    "text": "县乡优惠—三农商户类",
    "value": "9708"
  }]
  